// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View5_wrapper__3XVxd","topRow":"View5_topRow__2Wnug","mainUser":"View5_mainUser__3ZF7B","user":"View5_user__WA3Yg","bottomRow":"View5_bottomRow__AWAgX"};